export default "__VITE_ASSET__CfU8s4hv__"